// @ts-nocheck

import { type BasketState } from '../../../states/basket';
import { BasketItemStatuses, OddsChanges } from '../../../types/basket';
import { type GenericAction } from '../../../types/redux';

const basketUpdateItemValue = (state: BasketState, action: GenericAction): BasketState => {
  const { payload } = action;
  const { oddId, value } = payload ?? {};

  if (oddId) {
    const item = state.items[oddId];

    if (item) {
      const { status: itemStatus } = item;

      if (
        itemStatus === BasketItemStatuses.PENDING ||
        itemStatus === BasketItemStatuses.VALIDATED ||
        itemStatus === BasketItemStatuses.WAITING
      ) {
        return state;
      }

      const nextState = {
        ...state,
        items: {
          ...state.items,
          [oddId]: {
            ...state.items[oddId],
            value,
          },
        },
      };

      if (state.items[oddId].value !== value) {
        // $FlowFixMe
        nextState.items[oddId].changed = state.items[oddId].value < value ? OddsChanges.UP : OddsChanges.DOWN;
      }

      return nextState;
    }
  }

  return state;
};

export default basketUpdateItemValue;
